<template>
  <div id="main_existing_details" v-if="loaded">
    <div class="card part_1">
      
      <div class="fields_submit_container">
        <div class="fields_list_text_con">
          <div class="fields_list">
            <div class="fields_container">
              <li class="label_input project_name_container">
                <label>שם הפרויקט</label>
                <input type="text" v-model="form.name" >
              </li>
              <!-- <li class="label_input">
                <label class="title">סוג הפרויקט</label>
                <div class="box_switch">
                  <div :class="{ selected: form.project_type === 'building_renewal'}" @click="form.project_type = 'building_renewal'; form.num_building=1" class="a">התחדשות בניינית</div>
                  <div :class="{ selected: form.project_type === 'urban_renewal'}" @click="form.project_type = 'urban_renewal'" class="b">התחדשות מתחמית</div>
                </div>
              </li> -->
              <li class="num_building label_input">
                <label class="title">מס' בניינים</label>
                <input type="number" min="0" @input="handleBuildingChange" v-model="form.num_building"/>
                <!-- :disabled="Boolean(form.num_building === 1 && form.project_type === 'building_renewal')" -->
              </li>
            </div>
            <div class="fields_container">
              <li class="label_input flex-item">
                <label class="text">האם נפתח תיק במנהלת?</label>
                <div class="theme-switch-wrapper mid">
                  <span>כן</span>
                  <label class="theme-switch" for="checkbox_1">
                    <input v-model="form.is_file_opened_in_administration" type="checkbox" id="checkbox_1" />
                    <div class="slider round"></div>
                  </label>
                  <span>לא</span>
                </div>
              </li>
              <li  class="label_input">
                <label class="text">העלאת תיק מידע תכנוני</label>
                <!-- <div class="btn_b">
                  <span>בחירת קובץ</span>
                  <span class="icon upload"></span>
                </div> -->
                <GalleryInput v-model="form.main_file" @onUpload="form.main_file =  $event.id" :max="1"  />	
              </li>
              <li class="label_input" v-show="false">
                <label class="text">האם קיים מפקח בפרויקט?</label>
                <div class="theme-switch-wrapper mid">
                  <span>כן</span>
                  <label class="theme-switch" for="checkbox_2">
                    <input v-model="form.is_supervisor_in_project" type="checkbox" id="checkbox_2" />
                    <div class="slider round"></div>
                  </label>
                  <span>לא</span>
                </div>
              </li>
            </div>
          </div>
          <div class="text_box" v-html="get_word('create_project_part_1')"></div>
        </div>

        <div class="submit_area" @click="saveFirstInfo()">
          <div class="btn continue" :class="part_b_open ? 'disabled' : (form.num_building == 0 ? 'disabled' : '')">המשך</div>
          <!-- <router-link class="continue btn" :to="{ name: 'create_project', params: { step: 2 }}">המשך</router-link> -->
        </div>
      </div>
    </div>

    <div class="card directorate" v-if="form.is_file_opened_in_administration">
      <h4>דבר העירייה / מנהלת</h4>
      <div class="text_con" v-text="get_word('mnhalet_text', true)"></div>
      <GalleryInput  v-model="form.directorate_file" :max="1" @onUpload="form.directorate_file = $event.id" />	
    </div>

    <div class="card part_2 tabs_card" v-if="part_b_open">
      <div class="head">
        <ul class="building_container nav_tabs">
          <li @click="selectedBuildingNum = +building.numbuildingNum" :class="{active: selectedBuildingNum === +building.numbuildingNum}"  v-for="(building, i) in form.buildings" :key="i">
            <span>בניין</span>
            <span v-text="building.numbuildingNum"></span>
          </li>
        </ul>
      </div>
      <div class="content">
        <template v-for="(building, i) in form.buildings" :key="i">
            <Building :itemComp="building" v-show="selectedBuildingNum === +building.numbuildingNum" @update="building = $event" :token="form.token" @save="next"/>
        </template>
      </div>
    </div>
  </div>
</template>

<!-- <li class="num_building">
  <p class="title">מס' יחידות</p>
  <input type="number" min="0" v-model="num_building">
</li>
<li class="num_building">
  <p class="title">חנייה</p>
  <input type="number" min="0" v-model="num_building">
</li>
<li class="num_building">
  <p class="title">מחסן</p>
  <input type="number" min="0" v-model="num_building">
</li>
<li>
  <label>סוג נכס</label>
  <select>
      <option value="">בחירה מתוך הרשימה</option>
      <option value="1">1</option>
      <option value="2">2</option>
      <option value="3">3</option>
  </select>
</li> -->

<script>
import Building from './building.vue';
import GalleryInput from '../GalleryInput.vue';
  
export default {
  props: {
    edit_token:{
      type: String,
      default: ''
    }
  
  },
    components: {Building, GalleryInput},
    data() {
      return {
        isLoading: false,
        part_b_open: false,
        loaded: false,
      
        selectedBuildingNum: 1,
        form: {
          token: false,
          project_type: 'building_renewal',
          is_file_opened_in_administration: false,
          is_supervisor_in_project: true,
          num_building: 1,
          buildings: [],
          directorate_file: '',
        },

      }
  },
  computed: {
    currentBuilding() {
      return this.form.buildings.find((building) => this.selectedBuildingNum === +building.numbuildingNum);
    }
  },
  mounted(){
    if(this.edit_token){
      this.api({ action: 'projects/get_project_data',data: {token: this.edit_token}} ,(data) => {
        if(data.data){
          // if (data.data?.external_data?.num_offers && +data.data?.external_data?.num_offers > 0) {
          //   this.$router.push({ name: 'project', params: { token: this.edit_token}})
          // }
          this.form = data.data;
          
          if(this.form.num_building > 0 && this.form.buildings.length > 0) {
            this.part_b_open = true;
            this.$emit('startAutoSave');
          }
          this.loaded = true;
        }
      });
    }
    else{
      this.$nextTick(() => {
        this.loaded = true;
      }); 
    }
  },
  methods: {
    handleBuildingChange(){
      if(this.form.num_building < this.form.buildings.length){
         this.confirm(this.get_word('delete_building'), this.get_word('ok_delete'),this.get_word('cancel_delete')).then((result) => {
          if (result) {
                    this.selectedBuildingNum = 1;
                   this.part_b_open = false;
                  } else {
                    this.form.num_building = this.form.buildings.length;
                  }
          });
      }
      else{
          this.part_b_open = false;
      }
      
     
    },
    updateBuilding() {
      if(this.form.num_building > 0 && this.form.buildings.length == 0)
        {
          for (let i = 0; i < this.form.num_building; i++)
          {
            this.addBuilding();
          }
        }
        else if(this.form.num_building > 0 && this.form.buildings.length > 0)
        {
          if(this.form.num_building > this.form.buildings.length)
          {
            for (let i = this.form.buildings.length; i < this.form.num_building; i++)
            {
              this.addBuilding();
            }
          }
          else if(this.form.num_building < this.form.buildings.length)
          {
            this.form.buildings = this.form.buildings.slice(0, this.form.num_building);
          }
        }
    },
    saveFirstInfo(next = false){
      if(!this.isLoading){
        this.updateBuilding()
        if(this.edit_token && this.edit_token != '') this.form.token = this.edit_token;
        this.isLoading = true;
        console.log("this.form", this.form);

        this.api({ action: 'projects/save_project_data',data: this.form} ,(data) => { 
          if(data.data && !next){
            this.form.token = data.data.token;
            localStorage.setItem('project_token', data.data.token);
            console.log('/create_project/1/' + data.data.token);
            
            this.$router.push('/create_project/1/' + data.data.token);
            console.log("this.$router", this.$router);
            
            setTimeout(() => {
              this.part_b_open = true;
              this.isLoading = false;
              this.$emit('startAutoSave');
            }, 100);
          
          }
          // if (next) this.$emit('next');
        });
      }
    },
    addBuilding(){
      let building = {
            numbuildingNum:this.form.buildings.length + 1,
            token:'',
            address: '',
            email: '',
            note: '',
            main_permet_file: '',
            gar_file: '',
            join_house_file_1: '',
            join_house_file_2: '',
            join_house_file_3: '',
            gosh: '',
            helka: '',
            helka_property: '',
            floors_count: 0,
            gallary: [],
            floors: [],
            is_hafkaa: false,
            is_join_house: false,
            properties: [
              {type: 0, count: 0}
            ]
      };
      this.form.buildings.push(building);
      console.log(this.form.buildings.length);
      
      
      
    },
    nextStep() {
      this.next(null, true);
    },
    next(data, get_current=false){
      if(get_current && this.currentBuilding){
        data = this.currentBuilding;
      }
      if(data.numbuildingNum < this.form.num_building)
      {
        document.querySelector('.card').scrollIntoView({behavior: 'smooth', block: 'start'});
        this.saveFirstInfo();
        this.selectedBuildingNum++;
      }
      else{
        this.saveFirstInfo(true);
        this.$emit('next');
      }
  },
  back(){
    if(this.selectedBuildingNum > 1){
      this.selectedBuildingNum--;
    }
  },
  autoSave() {
      this.saveFirstInfo(false);
    }
  },
  watch: {
    selectedBuildingNum(newVal) {
      this.$emit('update:selectedBuildingNum', newVal);
    }
  }
}
</script>

<style lang="scss" scoped>
#main_existing_details { display: flex; flex-direction: column; gap: 24px;
  .flex-item{display:flex;}
  .building_fields {display: flex; flex-direction: column; gap: var(--gap_mid);}
  .part_1 {
    .fields_submit_container { display: flex; justify-content: space-between;  gap: var(--gap_big);
      .fields_list_text_con { display: flex; gap: var(--gap_xmid);
        .fields_list { display: flex; flex-direction: column; gap: 40px;
          .fields_container { display: flex;  align-items: center; gap: 60px;}
          li { 
            &.project_name_container { flex: 3;
              label { font-weight: bold; }
            }
            &.num_building {
              input[type=number] { outline: none; height: 30px; width: 70px; }
              input::-webkit-outer-spin-button,
              input::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
              }
      
              /* Firefox */
              input[type=number] {
                -moz-appearance: textfield;
              }
            }
            &.upload_file {
              .btn_b { padding: 0px 30px;}
            }
          }
        }

      }
      .submit_area { display: flex; flex-direction: column; justify-content: flex-end;
        .btn {padding-inline: 30px;}
      }
    }
  }
  .directorate { display: flex; gap: var(--gap_big);
    h4 { white-space: nowrap; align-content: center; }
    #gallery_wrapper { width: 300px;}
  }
  // .part_2 { padding: 48px 0px; 
  //   >.head {border-bottom: 1px solid var(--light_blue); padding-inline: 32px;
  //     .building_container { display: flex; gap: var(--gap_mid); overflow: auto;
  //       li { position: relative; flex-shrink: 0; cursor: pointer; display: flex; gap: 5px; padding-bottom: 10px;
  //         &.active {
  //           &::after {
  //             content: ''; position: absolute; bottom: 0; right: 0; left: 0; background: var(--title_color); height: 4px; border-radius: 8px;
  //           }
  //           span {color: var(--title_color);}
  //         }
  //         span {color: var(--text_s); font-size: var(--h4);}
  //       }
  //     }
  //   }
  //   >.content { padding: 40px 32px; }
  // }
}

@media(max-width:768px){
  #main_existing_details{
    display: flex;
      flex-direction: column;
      align-items: center;
     
    .part_1 {
      width:100%;
      padding: 20px 5px;
       .fields_submit_container {
        display: flex;
      flex-direction: column;
      align-items: center;
      margin:10px;
        .fields_list_text_con{
          display: flex;
          flex-direction: column;
          .fields_list{
            width:100%;
            align-self: center;
            .fields_container{
              display: flex;
              gap:20px;
              align-self: center;
              .num_building.label_input{
                .title{
                  font-size: 16px;
                }
                
              }
              .label_input.flex-item{
                display: flex;
                flex-direction: column;
              }
            }
          }
        }
       }
    }
     
  }
  
  .part_2 {
    width:100%;
    padding: 20px 5px;
    align-items: flex-start;
    .head{
      width:100%;
    }
    .building_container {
      flex-wrap: wrap;
    }
    .building_container{
      width:fit-content;
     justify-content: flex-start;
    }
    .content{
      width:100%;
      padding:10px 0;
    }
  }
 

}
</style>